<template>
  <header>
    <!--<button class="temp-showmodal" @click="showModal">show modal</button>-->
    <div class="header-inner">
      <router-link to="/"><img class="logo" src="@/assets/images/logo.png" alt="" /></router-link>
      <nav @mouseleave="showMenu = false">
        <a @mouseover="showMenu = true" href="javascript:;">Products</a>
        <a @mouseover="showMenu = true" href="javascript:;">Solutions</a>
        <a @mouseover="showMenu = true" href="javascript:;">Services</a>
        <router-link to="about" @mouseover.native="toggleMenu" @click.native="toggleMenu">Company</router-link>

        <div class="header-menus" :class="{ show: showMenu }">
          <div class="header-menus-inner">
            <div class="menu-list">
              <div class="menu-title">Product</div>
              <ul>
                <li class="bold">Trading Platforms</li>
                <li><router-link to="tap" @click.native="toggleMenu">TAP Trader</router-link></li>
                <li><router-link to="delkoithts" @click.native="toggleMenu">DELKOIT HTS</router-link></li>
              </ul>
            </div>
            <div class="menu-list">
              <div class="menu-title">Solutions</div>
              <ul>
                <li class="bold">Trading Platforms Components</li>
                <li><router-link to="webtradingterminal" @click.native="toggleMenu">Web Trader</router-link></li>
                <li><router-link to="mobiletradingterminal" @click.native="toggleMenu">Mobile App</router-link></li>
                <li><router-link to="ordermanagementsystem" @click.native="toggleMenu">Order Management System</router-link></li>
                <li><router-link to="riskmanagementsystem" @click.native="toggleMenu">Risk Management System</router-link></li>
                <li class="bold"><router-link to="shortselling" @click.native="toggleMenu">Short Selling Simulator</router-link></li>
                <li class="bold"><router-link to="derivativessimulator" @click.native="toggleMenu">Derivatives Simulator</router-link></li>
                <li class="bold"><router-link to="autotrading" @click.native="toggleMenu">Auto Trading System</router-link></li>
                <li class="bold"><router-link to="sto" @click.native="toggleMenu">STO Issuance System</router-link></li>
              </ul>
            </div>
            <div class="menu-list">
              <div class="menu-title">Services</div>
              <ul>
                <li class="bold"><router-link to="tradingsoftwaredev" @click.native="toggleMenu">Financial Software Development</router-link></li>
                <li class="bold"><router-link to="autotradingsignal" @click.native="toggleMenu">Auto Trading Signal Data</router-link></li>
              </ul>
            </div>
            <div class="menu-list active">
              <div class="menu-title">Company</div>
              <ul>
                <li class="bold"><router-link to="about" @click.native="toggleMenu">About</router-link></li>
                <li class="bold"><router-link to="contact" @click.native="toggleMenu">Contact</router-link></li>
              </ul>
            </div>
          </div>
          <div class="header-menus-footer">
            <div class="header-menus-footer-inner">
              <router-link to="contact" @click.native="toggleMenu">Contact</router-link>
              <!--
              <span>|</span>
              <a href="contactform">Demo 요청</a>
              -->
            </div>
          </div>
        </div>
      </nav>
      <div class="right-menu">
        <div class="lang">
          <img src="@/assets/icons/language.svg" alt="" />
          <button :class="{active: isActive === 'ko'}" @click="changeLocale('ko')">KOR</button>
          <span>|</span>
          <button :class="{active: isActive === 'en'}" @click="changeLocale('en')">EN</button>
        </div>
        <div class="hamburger">
          <MobileMenu @sideMenu="handleSidemenu" :openSide="openSide" />
        </div>
      </div>
    </div>
    
    <div class="sidemenu-bg" :class="{ open: openSide }" @click="openSide = false"></div>
    <div class="sidemenu" :class="{ open: openSide }">
      <MobileSideMenuItem name="Products">
        <a href="javascript:;">Trading Platforms</a>
        <router-link to="tap" @click.native="toggleSide">TAP Trader</router-link>
        <router-link to="delkoithts" @click.native="toggleSide">DELKOIT HTS</router-link>
      </MobileSideMenuItem>
      <MobileSideMenuItem name="Solutions">
        <a href="javascript:;">Trading Platforms Components</a>
        <router-link to="webtradingterminal" @click.native="toggleSide">Web Trader</router-link>
        <router-link to="mobiletradingterminal" @click.native="toggleSide">Mobile App</router-link>
        <router-link to="ordermanagementsystem" @click.native="toggleSide">Order Management System</router-link>
        <router-link to="riskmanagementsystem" @click.native="toggleSide">Risk Management System</router-link>
        <router-link to="shortselling" @click.native="toggleSide">Short Selling Simulator</router-link>
        <router-link to="derivativessimulator" @click.native="toggleSide">Derivatives Simulator</router-link>
        <router-link to="autotrading" @click.native="toggleSide">Auto Trading System</router-link>
        <router-link to="sto" @click.native="toggleSide">STO Issuance System</router-link>
      </MobileSideMenuItem>
      <MobileSideMenuItem name="Services">
        <router-link to="tradingsoftwaredev" @click.native="toggleSide">Financial Software Development</router-link>
        <router-link to="autotradingsignal" @click.native="toggleSide">Auto Trading Signal Data</router-link>
      </MobileSideMenuItem>
      <MobileSideMenuItem name="Company">
        <router-link to="about" @click.native="toggleSide">About</router-link>
        <router-link to="contact" @click.native="toggleSide">Contacts</router-link>
      </MobileSideMenuItem>
      <div class="lang mobile">
        <img src="@/assets/icons/language.svg" alt="" />
        <button :class="{active: isActive === 'ko'}" @click="changeLocale('ko')">KOR</button>
        <span>|</span>
        <button :class="{active: isActive === 'en'}" @click="changeLocale('en')">EN</button>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from './MobileMenu.vue';
import { bus } from '../main.js';
import MobileSideMenuItem from './MobileSideMenuItem.vue';
export default {
  components: { MobileMenu, MobileSideMenuItem },
  name: 'Header',

  data() {
    return {
      openSide: false,
      showMenu: false,
      isActive: `${this.$i18n.locale}`,
    };
  },

  created() {
    bus.$on('openSide', (e) => {
      this.openSide = e;
    });
  },

  mounted() {
  },

  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.isActive = locale;
      //this.$router.push({
      //  params: { lang: locale }
      //})
    },
    handleSidemenu(e) {
      this.openSide = false;
      bus.$emit(e, this.openSide);
      // this.openSide = e;
      //console.log(e);
    },
    showModal() {
      bus.$emit('showModal');
    },
    toggleMenu() {
      if ( this.showMenu ) {
        this.showMenu = false
      } else {
        this.showMenu = true
      }
    },
    toggleSide() {
      if ( this.openSide ) {
        this.openSide = false
      } else {
        this.openSide = true
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
